import { JsonValue } from "@adora/shared/utils/patch";

export function filterEmptyValues(data: object): JsonValue {
  const bodyParams: JsonValue = {};

  for (const [key, value] of Object.entries(data)) {
    if (Array.isArray(value)) {
      const filteredArray = value.filter((item) => item !== "");
      if (filteredArray.length > 0) {
        bodyParams[key] = filteredArray;
      }
    } else if (value !== "" && value !== undefined) {
      bodyParams[key] = value;
    }
  }

  return bodyParams;
}
